import { NgModule } from '@angular/core';
import { AppCommonModule } from '@shared/common/common.module';
import { CarerSelectComponent } from './carer-select.component';

@NgModule({
    imports: [
        AppCommonModule,
    ],
    exports: [
        CarerSelectComponent,
    ],
    declarations: [
        CarerSelectComponent,
    ]
})
export class AppCarerSelectModule {
}
